/**
 * @generated SignedSource<<802296d9d4def9946ad5a17c6d918d35>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditMainDocuments_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TravelDocumentSelect_data">;
  readonly " $fragmentType": "PackageEditMainDocuments_data";
};
export type PackageEditMainDocuments_data$key = {
  readonly " $data"?: PackageEditMainDocuments_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditMainDocuments_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditMainDocuments_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TravelDocumentSelect_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "7c4a6e219eb7c1de7a657851452b95a9";

export default node;
